<template>
    <transition
        enter-active-class="animated zoomInLeft"
        :leave-active-class="leaveActive"
    >
        <index-login-modal
            v-if="show"
            title="加入企业"
            des="企业确认 "
        >
            <div
                slot="content"
                class="content"
            >
                <h4 class="logo">
                    牛卡福网络
                </h4>
                <div class="company-name flex">
                    <span>{{ info.name }}</span>
                    <i class="certification" />
                </div>
                <!-- <p>企业地址：撒打算的</p>
                <p>人员规模：501～101人</p> -->
            </div>
            <div slot="foot">
                <span class="sure-text">确认要加入该企业吗？</span>
                <el-button
                    class="foot-btn"
                    type="primary"
                    :size="$store.state.element.elBtnSize"
                    :loading="isLoading"
                    @click="handleAgreeClick"
                >
                    设置完毕，进入首页
                </el-button>
                <el-button
                    class="foot-ignore-btn"
                    :size="$store.state.element.elBtnSize"
                    @click="handleIgnoreClick(1)"
                >
                    忽略
                </el-button>
            </div>
        </index-login-modal>
    </transition>
</template>
<script>
import indexLoginModal from './indexLoginModal'
import { joinCompany } from '@/api/login'
import { loginToUrl } from '@/utils'
import mixins from './mixins'

export default {
    components:{
        indexLoginModal,
    },
    mixins:[mixins],
    props:{
        index:{
            type:Number,
            default:0
        },
        info:{
            type:Number,
            default:()=>{}
        },
    },
    data(){
        return {
            isLoading:false,
            show:false,
            leaveActive:'animated zoomOutRight',
            // 登录返回的 默认企业 
            defaultCompanys:null
        }
    },
    mounted(){
        setTimeout(() => {
            this.show = true;
        }, 500);
    },
    created(){
        let companysList = _.cloneDeep(this.loginData.companys)
        this.defaultCompanys = companysList.find(item=>item.hasJoined)
    },
    methods:{
        // 忽略  type===1 else 确定 type===2
        handleIgnoreClick(type){
            // this.leaveActive = 'animated zoomOutRight'

            this.show = false;
            
            this.loginData.companys[this.index].hasJoined = type;
            
            if(!this.loginData.companys.find(item=>!item.hasJoined)){
                setTimeout(() => {
                    this.$store.commit(this.vuexModeuleName+'/updateStateData',{
                        isCompany:false
                    })

                    let subDomain = '';
                    // 找到点击确定按钮加入的企业 把选择的第一个 当成默认企业
                    let addCompanys = this.loginData.companys.find(item=>item.hasJoined===2);

                    if(this.defaultCompanys){
                        subDomain = this.defaultCompanys.subDomain;
                    }else if(addCompanys){
                        subDomain = addCompanys.subDomain;
                    }else{
                        this.clearToken()
                        return ;
                    }
                    loginToUrl(subDomain);

                }, 500);
            }
        },
        async handleAgreeClick(){
            this.leaveActive = 'animated zoomOutRight'
            this.isLoading = true;
            try {
                let data = await joinCompany({
                    companyId:this.info.companyId,
                    companyUid:this.info.companyUid,
                });
                if(data){
                    this.$$message(data.msg);
                    this.handleIgnoreClick(2);
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                }
            }catch(err){
                this.$$message('加入企业失败ERRPOR：'+err,'error')
                setTimeout(() => {
                    this.isLoading = false;
                }, 500);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .content{
        padding: 41px 97px 47px 56px;
    }
    .foot-btn,.foot-ignore-btn{
        float: right;
        padding:8px 12px;
        margin-right: 30px;
        background: rgba(33,84,189,1);
        border-color: rgba(33,84,189,1);
        border-radius: 4px;
        font-size:14px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:500;
        color:rgba(255,255,255,1);
    }
    .logo{
        width: 114px;
        height: 44px;
        margin-top: 4px;
        margin-bottom: 30px;
        background: url('../images/logo2.png') no-repeat center;
        background-size: cover;
        text-indent: -99999em;
    }
    .company-name {
        margin-bottom: 20px;
        align-items: center;
        i{
            display: block;
            width: 56px;
            height: 17px;
            background: url('../images/renzheng.png') no-repeat center;
            background-size: cover;
        }
        span{
            font-size:20px;
            font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            font-weight:500;
            color:rgba(18,28,64,1);
            line-height:28px;
            margin-right: 10px;
        }
    }
    p{
        height:20px;
        font-size:14px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:400;
        color:rgba(120,127,149,1);
        line-height:20px;
        margin-bottom: 5px;
    }
    .sure-text{
        font-size:14px;
        font-family: "PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-weight:400;
        color:rgba(247,78,20,1);
        line-height:20px;
        margin-left: 56px;
    }
    .foot-ignore-btn{
        background: #fff;
        border-color: rgba(216,217,225,1);
        color:rgba(120,127,149,1);
        margin-right: 15px;
    }
</style>